<template>
  <div
    id="app"
    ref="app"
    class="planbook_result_page"
    :class="[
      appClass,
      APP_CHANNEL,
      isShowFooterBar ? 'with_footer' : ''
    ]"
    :style="appStyle"
  >
    <ExpireTips v-if="isExpire" :plain-result-data="plainResultData" />
    <template v-else>
      <template v-if="tmpData">
        <template v-if="replayLoading">
          <bxs-default-page :large="!0" type="comment" text="视频加载中..." />
        </template>
        <template v-else>
          <Cover v-if="isCoverShow" :plan="plan" @close="closeCover" />
          <WechatAuthTips />
          <template v-if="isPolicyCheck">
            <PolicyCheckInfor
              :uuid="uuid"
              :policy-info="plainResultData.policyInfo"
            />
          </template>
          <template v-else>
            <ResultBanner
              :title="title"
              :tmp-data="tmpData"
              :card="card"
              :token="token"
              :uuid="uuid"
              :theme-settings="themeSettings"
              :theme-list="themeList"
              :is-for-presentation="isForPresentation"
              @done="isResultBannerDone = true"
            />
          </template>

          <!-- 人/险种信息汇总 -->
          <Person
            v-if="personData"
            ref="person"
            :is-policy="isPolicyCheck"
            :person-data="personData"
            :table-data="tableData"
            :common-data="productCommonData"
            :total-baof="totalBaof"
            :tag-list="tagList"
            @new-insure-detail="handleOpenNewInsureDetail"
          />

          <template v-if="hasLiability">
            <!-- 右侧模式切换 -->
            <LiabilityToggleButtons
              v-if="isTypeToggle"
              :is-screen-capture-show="isScreenCaptureShow"
              :show-type="showType"
              :kind="kind"
              data-stat-id="qhxsms"
              :fixed="insTypeNavFixed"
              :data-stat-ep="JSON.stringify({ productId: insuranceTypeId })"
              @toggle="toggle"
              @toggle-kind="kind = $event"
            />

            <div data-stat-id="zr" data-stat-expose />
            <!-- 责任 -->
            <div ref="insResultBox">
              <keep-alive>
                <template v-if="showType">
                  <LiabilityDetailGroupByInsurance
                    ref="insResult"
                    :template="tmpData"
                    :class="isTypeToggle ? '' : 'ins-result-v2'"
                    :product-name-list="productNameListData"
                    :miniprogram="miniprogram"
                    @set-instype="
                      insTypeList = $event;
                      insTypeInit = true;
                    "
                    @open-disease="openDiseaseBubble"
                    @open-terms="openTermsBubble"
                  />
                </template>
                <template v-else>
                  <LiabilityDetailGroupByType
                    ref="insTypeResult"
                    :template="tmpData"
                    :kind="kind"
                    :class="isTypeToggle ? '' : 'ins-result-v2'"
                    :product-name-list="productNameListData"
                    @set-instype="
                      insTypeList = $event;
                      insTypeInit = true;
                    "
                    @set-accIns="accType = $event"
                    @open-disease="openDiseaseBubble"
                  />
                </template>
              </keep-alive>
            </div>
          </template>

          <!-- 计划书2.0 保障疾病 -->
          <DiseaseTypeNew
            ref="diseaseTypeNew"
            :is-for-presentation="isForPresentation"
            :is-host="isHost"
            :template="tmpData"
          />

          <!-- [保单年检]单险种责任 -->
          <SingleInsurance
            v-model="isSingleInsuranceShow"
            :template-data="tmpData"
          />

          <!-- 利益演示 -->
          <InterestDemo
            ref="InterestDemoV2"
            :style="{
              width: '94.667%',
            }"
            :is-for-presentation="isForPresentation"
            :is-screen-capture-show="isScreenCaptureShow"
            :init-result-data="tmpData"
            :person-data="personData"
            :params="{
              uuid,
            }"
            @set-interest-key="
              interestKeyList = $event;
              interestKeyInit = true;
            "
            @has-interest-demo="hasInterestDemo = $event"
            @has-bonus="hasBonus = $event"
            @update-account-map="setAccountMap"
          />

          <Advertising :position="9" :relation-id="insuranceTypeId" />

          <!-- 条款 -->
          <InsuranceClause :uuid="uuid" :miniprogram="miniprogram" />

          <template v-if="footData">
            <BusinessCard
              :data="footData"
              :is-screen-capture="isScreenCaptureShow"
              :is-policy-check="isPolicyCheck"
            />
            <FooterBar
              v-if="isShowFooterBar"
              :jump-source="jumpSource"
              :data="footData"
              :liability-show-type="Number(showType)"
              :plain-result-data="plainResultData"
              :is-support-record-screen="isSupportRecordScreen"
              :interaction-on="tmpData.interactionSwitchOn"
              :is-screen-capture="isScreenCaptureShow"
              :is-for-presentation="isForPresentation"
              :is-trades="tradesType"
              :recording-state="recordingState"
              :is-policy-check="isPolicyCheck"
              :theme-settings="themeSettings"
              :export-risk-has-interest-demo="hasInterestDemo"
              :export-risk-has-bonus="hasBonus"
              @generate="isExportShow = true"
              @generate-image="exportPbShow = 2"
              @share="handleShare"
              @record="recordScreenShow = true"
              @interpretation="interpretationScheme = true"
              @screen-capture="screenCapture"
              @openThemePicker="openThemePicker"
              @openInterestSettingPopup="openInterestSettingPopup"
            />
          </template>

          <NameExplain
            v-if="interestKeyInit && insTypeInit && !isPolicyCheck"
            ref="nameExplain"
            :liability-tag-list="insTypeList"
            :interest-key-list="interestKeyList"
            :sort-list="sortList"
            @done="isNameExplainDone = true"
            @send-delta="syncDelta"
          />

          <Risk
            v-if="tmpData"
            ref="riskPrompt"
            :has-interest-demo="hasInterestDemo"
            :has-mul-ins-account="hasMulInsAccount"
            :has-bonus="hasBonus"
          />

          <Qrcode v-if="!isScreenCaptureShow" :url="shareLink" />

          <!-- 回流弹窗 -->
          <ReflowBox
            :uuid="uuid"
            :insurance-type-id="insuranceTypeId"
            :insured-info="personData.insuredInfo"
            :is-pre-invitation="isPreInvitationShow"
          />

          <!-- 续保保费 -->
          <bxs-bottom-sheets
            v-model="newInsure.show"
            class="newinsure-bottom-sheets"
            title="续保保费"
            :use-b-scroll="false"
            :prevent-scroll-through="true"
          >
            <NewInsureDetail :new-insure="newInsure" />
          </bxs-bottom-sheets>

          <!-- 导出 -->
          <!-- 图片。文档改由 export-selection 处理 -->
          <PlanToExport
            v-model="exportPbShow"
            :miniprogram="miniprogram"
            @screen-capture="screenCapture"
          />
          <!-- 文档 -->
          <ExportSelection
            v-model="isExportShow"
            :miniprogram="miniprogram"
            @saveInteractionSetting="saveInteractionSetting"
          />

          <!-- 讲解方案选择（录屏、同屏讲解）  -->
          <SchemeSelection
            v-model="interpretationScheme"
            :miniprogram="miniprogram"
            :is-support-record-screen="isSupportRecordScreen"
            :interaction-on="tmpData.interactionSwitchOn"
            @record-screen="recordScreenShow = true"
            @invitation="isPreInvitationShow = true"
            @support-warning="isSupportShow = true"
            @share="handleToInterpretation"
            @began-to-record-screen="$refs.recordScreen.handleCount(true)"
            @wechat-invitation="handleToInterpretation(true)"
          />

          <!-- [录屏] -->
          <RecordScreen
            v-if="!isForPresentation"
            ref="recordScreen"
            v-model="recordScreenShow"
            @close="
              recordScreenShow = false;
              isBoardShow = false;
            "
            @to-start="
              recordScreenShow = false;
              recordingState = true;
            "
            @to-end="
              recordingState = false;
              isBoardShow = false;
            "
          />

          <!-- 画笔（录屏、同屏讲解） -->
          <div
            v-if="isForPresentation || recordingState"
            class="floating-toolbelt-wrapper"
          >
            <div
              v-if="(isForPresentation && isHost) || recordingState"
              class="drawing-btn floating-toolbelt"
              :class="{ cur: isBoardShow }"
              @click="handleToggleBoard"
              @touchmove.prevent
            >
              <i class="iconfont icon-write_line" />画笔
            </div>
            <DrawingBoard
              v-if="isBoardShow"
              ref="drawingBoard"
              :is-host="isHost"
              @send-delta="syncDelta"
            />
          </div>

          <!-- [同屏讲解] 工具带 -->
          <PresentationToolbelt
            v-if="isShowPresentationToolbelt"
            v-show="!isBoardShow"
            ref="presentationToolbelt"
            :is-replay="isReplay"
            :is-host="isHost"
            :wechat-info="plan"
            :agent-info="card"
            :host-user-id="hostUserId"
            @presenter-change="isHost = $event"
            @synchronous-history="synchronousHistory"
            @page-sync="onPageSync"
            @pre-page-sync="onPrePageSync"
            @request-control="isHost = $event"
            @request-host-id="hostUserId = $event"
            @quit-presentation="isForPresentation = false"
            @tim-ready="replayTim = $event"
            @enter-success="savePresentationInfo"
          />

          <!-- [同屏讲解] 发起弹窗 -->
          <bxs-popup
            v-model="isPreInvitationShow"
            class="pre-popup"
            :close-on-click-overlay="false"
          >
            <PrePresentation
              @share="handleToInterpretation"
              @close="isPreInvitationShow = false"
            />
          </bxs-popup>

          <!-- 小程序不支持弹窗 -->
          <bxs-popup
            v-model="isSupportShow"
            class="not-support-miniprogram"
            :close-on-click-overlay="false"
          >
            <div class="tips">
              抱歉，小程序暂不支持此功能，请下载保险师APP使用哦
            </div>
            <div class="btn" @click="isSupportShow = false">
              知道了
            </div>
          </bxs-popup>

          <!-- [同屏讲解] 高度适配遮罩 -->
          <div
            v-if="isForPresentation && viewOverlayShow"
            class="view-overlay"
            :style="{ height: `${viewOverlayHeight}px` }"
            @touchmove.prevent
          />

          <!-- [同屏讲解] 讲解遮罩 -->
          <div
            v-if="isForPresentation && !isHost"
            class="interpretation-over"
            :class="{ lock: isBoardShow }"
            @touchmove.prevent
          />

          <!-- [同屏讲解] 同步定位 -->
          <SharingScreen
            v-if="isForPresentation && isSharingScreenShow"
            v-model="elementsTop"
          />

          <!-- [同屏讲解] 是否有c，进入讲解房间的入口 -->
          <InterpretationNotice
            v-if="
              (BC.isBxs || BC.isToBApp) &&
                !CM.getUrlParam('roomId') &&
                tmpData.interactionSwitchOn
            "
          />
        </template>

        <!-- [同屏回放] 遮罩 -->
        <ReplayToolbelt
          v-if="isReplay"
          :tim="replayTim"
          :replay-loading="replayLoading"
          :is-board-show="isBoardShow"
          :is-for-presentation="isForPresentation"
          @presenter-change="isForPresentation = $event"
          @reset="reset"
        />
        <!-- 有奖征集 -->
        <CashReward v-if="isDataCollection" :product-item="matchedProductItem" @close="handleCloseCashReward" />
      </template>
      <BxsBg v-else :value="isBxsApp" />
    </template>

    <ThemePopup
      v-model="themePopupConfig.visible"
      :columns="themePopupConfig.columns"
      :default-theme="themePopupConfig.defaultTheme"
      :preview-theme="themePopupConfig.previewTheme"
      @change="onChangeTheme"
    />
  </div>
</template>

<script>
import qs from "qs";
import Vue from "vue";
import { mapState, mapActions } from 'vuex'
import axios from "axios";
import { get as _get, cloneDeep } from "lodash";
import Vant from "vant";

import { BottomSheets, MessageBox, Popup } from "bxs-ui-vue";
import BxsToolsUi from "bxs-tools-ui";
import UA from "ua-device";
import VConsole from "vconsole";

import { IS_LOCALHOST_ENV, CONTENT_HOSTNAME, URL_PARAM, isApp, isWeChat, APP_CHANNEL, WX_AUTH_PUBLIC_APPID, isBxsApp, getUrlParams, IS_APP_PLATFORM, weixinFontSizeHandler } from "common/utils";
import * as API from "api/index";
import * as DOM from "common/js/dom";
import * as CM from "common/js/common";
import { addVisitorReadEvent } from "@/api/common.js";
import * as FMT from "common/js/format";
import { mobileDevice } from "common/js/mobileDevice";
import logger from "base/logger";
import * as BC from "base/config";
import { isWeCom } from 'base/config'
import * as CONFIG from "@/pages/planbkTemplate/base/config";
import { getPolicyDetailInfo, getDataCollectionMissionExist,getIsJumpToCompare3Exist } from "./js/api";
import { initNativeShare, initWechatShare } from "./js/handler";
import { updateThemeVariables } from '@/config/theme.js'

// 同屏
import pageSyncMixin from "@/pages/planbkTemplate/tim-adapter/page-sync-mixin";
// 版本限制
import versionLimit from "@/pages/planbkTemplate/base/versionLimit";

// 通用组件
import DiseaseTypeNew from "@/components/diseaseType/diseaseTypeNew.vue";
import Advertising from "@/components/banner/advertising.vue";
import MiniprogramFooter from "@/components/footer/miniprogramFooter.vue";
import NewInsureDetail from "@/components/person/newInsureDetail.vue";
import ExportSelection from "@/components/drawer/ExportSelection/ExportSelection.vue";
import BxsBg from "@/components/loading/bxsBg.vue";
import WechatAuthTips from "@/components/wechatAuthTips/index.vue";
// 老结果页组件
import Cover from "@/pages/planbkTemplate/components/cover.vue";
import PolicyCheckInfor from "@/pages/planbkTemplate/components/policy/policyCheckInfor.vue";
import SingleInsurance from "@/pages/planbkTemplate/components/policy/singleInsurance.vue";
import Qrcode from "@/pages/planbkTemplate/components/qrcode.vue";
import ReflowBox from "@/pages/planbkTemplate/components/reflowBox.vue";
import PlanToExport from "@/pages/planbkTemplate/components/planToExport.vue";
import SchemeSelection from "@/pages/planbkTemplate/components/schemeSelection.vue";
import RecordScreen from "@/pages/planbkTemplate/components/recordScreen.vue";
import DrawingBoard from "@/pages/planbkTemplate/components/drawingBoard/drawingBoard.vue";
import PresentationToolbelt from "@/pages/planbkTemplate/components/PresentationToolbelt.vue";
import PrePresentation from "@/pages/planbkTemplate/components/prePresentation.vue";
import SharingScreen from "@/pages/planbkTemplate/components/sharingScreen.vue";
import InterpretationNotice from "@/pages/planbkTemplate/components/interpretationNotice.vue";
import ReplayToolbelt from "@/pages/planbkTemplate/components/replayToolbelt/replayToolbelt.vue";
// 从通用组件拷贝过来修改的组件
import Person from "./components/person/index.vue";
import LiabilityToggleButtons from "./components/liability/toggleButtons.vue"; // src/components/toggleTemp/toggleTempRight.vue
import LiabilityDetailGroupByInsurance from "./components/liability/detailGroupByInsurance";
import LiabilityDetailGroupByType from "./components/liability/detailGroupByType.vue";
import InsuranceClause from "./components/insuranceClause/index.vue"; // src/components/insuranceClause.vue
import NameExplain from "./components/nameExplain/index.vue";
import Risk from "./components/risk/index.vue";
import ThemePopup from "./components/themePopup/index.vue";

// 当前页面的新组件
import ExpireTips from "./components/expireTips/index.vue";
import ResultBanner from "./components/banner/index.vue";
import InterestDemo from "./components/interestDemo/index.vue";
import BusinessCard from "./components/businessCard/index.vue";
import FooterBar from "./components/footerBar/index.vue";
import CashReward from "./components/cashReward/index.vue";
import { buriedInit } from 'common/js/common'
import { shareDirect } from "@/common/bridge";

Vue.use(Vant);
Vue.use(MessageBox);
console.log('BxsToolsUi：', BxsToolsUi.version)

const { theme, weapp, shareFrom, sharePlatform, isShareFormWeApp, pbType, roomId } = URL_PARAM
export default {
  components: {
    // 通用组件
    DiseaseTypeNew,
    Advertising,
    MiniprogramFooter,
    NewInsureDetail,
    ExportSelection,
    BxsBg,
    WechatAuthTips,
    // 老结果页组件
    Cover,
    PolicyCheckInfor,
    SingleInsurance,
    Qrcode,
    ReflowBox,
    PlanToExport,
    SchemeSelection,
    RecordScreen,
    DrawingBoard,
    PresentationToolbelt,
    PrePresentation,
    SharingScreen,
    InterpretationNotice,
    ReplayToolbelt,
    // 从通用组件拷贝过来修改的组件
    Person,
    LiabilityToggleButtons,
    LiabilityDetailGroupByInsurance,
    LiabilityDetailGroupByType,
    InsuranceClause,
    NameExplain,
    Risk,
    // 当前页面的新组件
    ExpireTips,
    ResultBanner,
    InterestDemo,
    BusinessCard,
    FooterBar,
    CashReward,
    ThemePopup,
    [Popup.name]: Popup,
    [BottomSheets.name]: BottomSheets,
  },
  mixins: [pageSyncMixin, versionLimit],
  data() {
    return {
      isExpire: false,
      isCoverShow: true,
      isPageDone: false,

      plainResultData: null, // 从接口获取的、未处理的数据

      personData: null,
      tableData: null,
      tmpData: null,
      footData: null,
      showType: 0,
      kind: null,
      plan: {
        sex: "",
        name: "",
        avatar: "",
        nickname: "",
        token: null,
        pbUuid: null,
        salesUuid: null,
        authed: false,
      },
      insTypeList: [],
      disease: {
        show: false,
        activePath: [],
        height: 0,
      },
      accountsData: [],
      card: {},
      termsList: [],
      accType: false,
      miniprogram: false,
      testGroup: {
        show: false,
        url: "",
        text: "",
        code: 0,
        image: "",
      },
      riskType: null,
      tagList: [],
      springData: {},
      insuranceInfor: {},
      productCommonData: [],
      termsActiveId: null,
      jumpSource:0,//0表示不显示利益演示 ，1显示
      newInsure: {
        show: false,
        data: {},
      },
      exportPbShow: 0, // 导出文档
      isExportShow: false,
      insTypeNavFixed: false, // 责任导航锚点
      interpretationScheme: false, // 讲解方案
      interestKeyList: [], // 利益演示字段
      interestKeyInit: false,
      hasInterestDemo: false, // 是否有利益演示（由 InterestDemo 子组件同步）
      hasBonus: false, // 是否有分红险（由 InterestDemo initInterest 返回数据中 bonus 有值同步）
      insTypeInit: false,
      recordScreenShow: false,
      recordingState: false,
      isBoardShow: false,
      roomId: null,
      hasPendingInvitation: false,
      isPreInvitationShow: false,
      isSingleInsuranceShow: true,

      isNameExplainDone: false,
      isResultBannerDone: false,

      isForPresentation: !!CM.getUrlParam("roomId"),
      isSupportShow: false, // 不支持小程序弹窗
      isScreenCaptureShow: true,
      shareLink: "", // 分享最终链接

      replayLoading: false,
      isReplay: !!CM.getUrlParam("replay"),
      replayTim: null,
      autoOauth: false,
      fromWyjhs: false,

      isWxAuthed: false,
      themeSettings: {
        defaultTheme: "",
        previewTheme: "",
      },
      isDataCollection: false,
      matchedProductItem: null,
      themePopupConfig: {
        visible: false,
        columns: []
      },
      isBxsApp
    };
  },
  computed: {
    ...mapState(['themeList']),
    inWechat() {
      return APP_CHANNEL === "WECHAT";
    },
    isShowFooterBar () {
      const { footData, isPolicyCheck, tradesType, isForPresentation } = this
      if (APP_CHANNEL === 'NUOYA') {
        return footData && footData.memeber
      }
      if (['BaoXiaoZhu', 'H5_BXZ'].includes(APP_CHANNEL)) {
        return true
      }
      if (pbType === 'annual_survey' && (!!sharePlatform || !!isShareFormWeApp)) {
        return false
      }
      if (['WECHAT_GAOKE'].includes(APP_CHANNEL)) {
        return !sharePlatform
      }
      if (['WECHAT_GAOKE_CUSTOMER'].includes(APP_CHANNEL)) {
        return false
      }
      // 保单年检，c端 && 单个交易产品，不显示<投保按钮> => 不显示foot
      if (isPolicyCheck) {
        return !tradesType && isApp
      }
      if (['WXMP', 'WXMP_BXZ'].includes(APP_CHANNEL)) {
        return !weapp && shareFrom !== 'mpH5ShareBtn'
      }
      return (isApp || tradesType || isWeCom) && !isForPresentation
    },
    appClass() {
      const { footData, tradesType, isPageDone, replayLoading } = this;
      return {
        higher: footData && tradesType,
        done: isPageDone && !replayLoading
      };
    },
    appStyle() {
      const { viewOverlayShow, viewOverlayHeight } = this;
      return {
        "margin-bottom": `${viewOverlayShow ? viewOverlayHeight : 0}px`,
      };
    },
    hasLiability () {
      const liabilities = _get(this, 'tmpData.liabilities') || []
      return liabilities.some(item => {
        const hasAccidentLiabilities = (_get(item, 'accidentLiabilities') || []).some(e => e.liabilities && e.liabilities.length)
        const hasInsuranceLiabilities = (_get(item, 'insuranceLiabilities') || []).some(e => e.liabilities && e.liabilities.length)
        return hasAccidentLiabilities || hasInsuranceLiabilities
      })
    },
    // 是否有万能险：productGroupList[0].prodOrderList 下任一 product 的 mulInsOrderList 中存在 account === true
    hasMulInsAccount() {
      const prodOrderList = _get(this, 'tmpData.resultData.productGroupList[0].prodOrderList') || []
      return prodOrderList.some(prod => (prod.mulInsOrderList || []).some(ins => ins.account === true))
    },
    // 单款可投保产品
    tradesType() {
      const { footData, tmpData } = this;
      const productLen =
        tmpData &&
        Array.isArray(tmpData.liabilities) &&
        tmpData.liabilities.length;

      return (
        footData &&
        Array.isArray(footData.trades) &&
        footData.trades.length === 1 &&
        productLen === 1
      );
    },
    // 保单年检
    isPolicyCheck() {
      return this.pbType === "annual_survey";
    },
    // 计算同屏模块位置组件是否显示
    isSharingScreenShow() {
      const { isResultBannerDone, isNameExplainDone } = this;
      return isResultBannerDone && isNameExplainDone;
    },
    isShowPresentationToolbelt() {
      return this.isForPresentation && (!this.inWechat || this.isWxAuthed);
    },
    // 是否显示险种/责任切换
    isTypeToggle() {
      return (
        this.tmpData && !this.isSingleInsuranceShow && !this.isForPresentation
      );
    },
  },
  watch: {
    themeList: {
      handler (list) {
        if (!list || !list.length || !this.themeSettings) return
        const { themeSettings } = this
        const exist = (key) => key && list.some(e => e.key === key)
        const first = _get(list, '[0].key')
        // 修正 previewTheme：URL 的 theme 不在列表里时，用皮肤列表中第一个皮肤
        if (!exist(themeSettings.previewTheme) && first) {
          themeSettings.previewTheme = first
        }
        // 修正 defaultTheme：默认皮肤不在列表里时，也用皮肤列表中第一个皮肤
        if (!exist(themeSettings.defaultTheme) && first) {
          themeSettings.defaultTheme = first
        }
      }
    },
    exportPbShow: {
      handler(value) {
        this.syncDelta({ pbData: { exportPbShow: value } });
      },
    },
    "disease.show": {
      handler(value) {
        this.stopBodyScroll = value;
        !value && this.syncDelta({ pbData: { isDiseasesShow: value } });
      },
    },
    termsActiveId: {
      handler(value) {
        this.stopBodyScroll = value;
      },
    },
    replayLoading: {
      handler(value) {
        this.CM.loading(value);
      },
    },
    "themeSettings.previewTheme": {
      handler(newTheme) {
        updateThemeVariables(newTheme, this.themeList)
      }
    }
  },
  async created() {
    this.BC = BC;
    this.CM = CM;
    if (
      appBridge &&
      appBridge.isCurrentSharedPageExpired &&
      appBridge.isCurrentSharedPageExpired()
    ) {
      this.initPage();
      this.isExpire = true;
      return;
    }
    if(IS_APP_PLATFORM && !['WECHAT_GAOKE_CUSTOMER'].includes(APP_CHANNEL)) {
      await this.$store.dispatch('setUserInfo')
    }
    if (BC.isWeCom) {
      this.miniprogram = false;
      this.initPage();
    } else if (['WXMP', 'WXMP_BXZ'].includes(APP_CHANNEL)) {
      this.miniprogram = true
      this.initPage();
    } else {
      this.miniprogram = false;
      this.initPage();
    }
    if (window.appBridge && appBridge.checkAppFeature("NEED_TEXT_ZOOM")) {
      appBridge.needTextZoom();
    }
  },
  mounted () {
    weixinFontSizeHandler()
  },
  methods: {
    ...mapActions(['getThemeList']),
    initPage() {
      this.initSearch();
      const {
        uuid,
        token,
        isReplay,
        miniprogram: isMiniprogram,
        themeSettings,
        appPlatform
      } = this;
      const vm = this;
      if (!uuid) return;
      this.fetchData({ uuid })(async (id, heartSec) => {
        // TODO: 为了快速实现的快捷做法
        this.plan.token = token;
        this.plan.pbUuid = this.uuid;
        this.plan.salesUuid = this.card.userUuid;
        this.buried(id, heartSec);
        const {
          $refs,
          isPolicyCheck,
          isSupportRecordScreen,
          isForPresentation,
          showType,
          title,
          tmpData,
          autoOauth,
          fromWyjhs,
        } = this;
        initNativeShare({
          isMiniprogram,
          $refs,
          isPolicyCheck,
          isSupportRecordScreen,
          isForPresentation,
          showType,
          title,
          tmpData,
          getAppParams: () => this.getAppParams(),
          getThemeSettings: () => themeSettings,
          callback: (nativeShareData) => {
            for (const k in nativeShareData) {
              if (
                [
                  "shareLink",
                  "asConfig",
                  "isPreInvitationShow",
                  "recordScreenShow",
                ].includes(k)
              ) {
                this[k] = nativeShareData[k];
              }
            }
          },
        });
        initWechatShare({
          token,
          appPlatform,
          isReplay,
          isMiniprogram,
          isPolicyCheck,
          showType,
          title,
          tmpData,
          autoOauth,
          fromWyjhs,
          callback(wechatShareData) {
            const { clientUuid, insuranceTypeId, heartSec } = wechatShareData;
            vm.clientUuid = clientUuid;
            vm.buried(insuranceTypeId, heartSec);
            vm.qaFeedback();
            vm.addVisitorReadEvent();
            API.getClientInfo({ token }).then(
              ({ data: { success, data } } = { data: {} }) => {
                if (success && data) {
                  vm.plan.avatar = data.headimgurl;
                  vm.plan.nickname = data.nickname;
                }
                vm.isWxAuthed = true;
              }
            );
          },
        });
      });
      this.getThemeList()
    },
    initSearch() {
      this.coverTimer = null;
      this.themeSettings.previewTheme = theme;
      if (APP_CHANNEL === 'NUOYA') {
        this.themeSettings.previewTheme = 'theme_nuoya_default'
        const params = getUrlParams();
        params.theme = this.themeSettings.previewTheme;
        const url = location.origin + location.pathname + `?${qs.stringify(params)}`;
        if (window.history && typeof window.history.replaceState === "function") {
          window.history.replaceState(null, '', url);
        }
      }
      this.curYear = parseInt(CM.getUrlParam("year")) || 0;
      this.dfSort = CM.getUrlParam("dfSort");
      this.uuid = CM.getUrlParam("uuid");
      this.cardUuid = CM.getUrlParam("cardUuid");
      this.userUuid = CM.getUrlParam("userUuid");
      this.token = CM.getToken(CONFIG.TOKEN_KEY, CONFIG.TIMESTAMP_KEY);
      this.inGroup = CM.getUrlParam("inGroup");
      this.autoOauth = CM.getUrlParam("autoOauth");
      this.pathUuid = CM.getUrlParam("pathUuid");
      // 保单托管-详情页
      this.isWeapp = CM.getUrlParam("weapp");
      // 三招两式
      this.tsType = CM.getUrlParam("tsType");
      this.tsTypeId = CM.getUrlParam("tsTypeId");
      // 保单年检
      this.pbType = CM.getUrlParam("pbType");
      // 公众号
      this.fromWyjhs = CM.getUrlParam("fromWyjhs") == 1;
    },
    fetchData({ uuid }) {
      const { isPolicyCheck, userUuid } = this;
      return (callbk = () => {}) => {
        const apiPromise = isPolicyCheck
          ? getPolicyDetailInfo({
              insurePlanPolicyId: Number(URL_PARAM.policyId),
              resultUuid: uuid,
            })
          : API.getResult({
              uuid,
              userUuid: userUuid || undefined,
            });
        apiPromise.then(async (res) => {
          const { success, data, info } = res.data;
          if (!success) {
            this.$toast(info);
            return;
          }
          this.plainResultData = data;
          const { heartSec, insuranceType, resultData, status } = data;
          if (status === "expire") {
            this.isExpire = true;
          }
          data.trades = [];
          this.matchData(data);

          this.shareInfo = {
            name: "",
            img: isPolicyCheck
              ? BC.POLICY_WECHAT_SHARED_LOGO
              : insuranceType.wechatSharedLogoUrl,
          };
          if (insuranceType) {
            this.insuranceInfor = insuranceType;
            if (resultData.title) {
              this.insuranceInfor = {
                ...insuranceType,
                name: resultData.title,
              };
            }
            this.oauthExtendMsg = insuranceType.name;
          }
          if (data.card) {
            // img.winbaoxian.com 域名不允许跨域？（canvas无法绘制头像）
            data.card.photo = String(data.card.photo).replace(
              /img\.winbaoxian\./,
              "media.winbaoxian."
            );
            // 修复http 图片资源在 https网页中绘制报错问题
            if(data.card.photo.startsWith('http://') && data.card.photo.includes('winbaoxian.com')) {
              const protocol = window.location && location.protocol
              data.card.photo = data.card.photo.replace('http://', `${protocol}//`)
            }
            this.shareInfo.name = data.card.name;
            this.cardUuid = data.card.uuid;
          }

          callbk(resultData.insuranceTypeId, heartSec);
          //判断是否单险种单产品
          let insuranceSize = 0;
          const productList = _get(data, 'resultData.productGroupList[0].prodOrderList', []);
          const productSize = productList.length||0;
          const insuranceId=_get(productList[0],'mulInsOrderList[0].key')
          if (productSize&&productSize === 1) {
            const mulInsOrderList = _get(productList[0], 'mulInsOrderList', []);
            insuranceSize = mulInsOrderList.length;
          }
          const isFromPresentation = CM.getUrlParam("roomId") || CM.getUrlParam("inGroup");
          // 只处理保险师app环境，其他不管。From hyw
          const isShowCompare3Button = productSize === 1 && insuranceSize === 1 && ['BXS', 'BaoXiaoZhu', 'H5_BXZ'].includes(APP_CHANNEL)
          let isJumpToCompare3 = false
          if(isShowCompare3Button && !isFromPresentation){
            await getIsJumpToCompare3Exist(insuranceId).then(res => {
              if (res && res.data && res.data.success) {
                isJumpToCompare3 = _get(res.data, 'data', false);
              }
            }).catch(err => {
              console.error(err);
            });
          }
          if(isShowCompare3Button && isJumpToCompare3){
            this.jumpSource = 1
          }
          // 线上启动 VConsole：被保人姓名 === vc_debug
          const _personOrderList =
            _get(data, "resultData.personData.personOrderList") || [];
          const _insuredInfo = _personOrderList.find(
            (p) => p.key === "insuredInfo"
          );
          const _insuredName = _get(_insuredInfo, "name");
          if (_insuredName === "vc_debug") {
            const vConsole = new VConsole();
            vConsole.setOption({ disableLogScrolling: true });
            const _network = _get(vConsole, "pluginList.network");
            const _disableLogScrolling = _get(
              vConsole,
              "option.disableLogScrolling"
            );
            if (_network) {
              _network.scrollToBottom = function () {
                if (!_disableLogScrolling) {
                  const $box = vConsole.$.one(".vc-content");
                  $box.scrollTop = $box.scrollHeight - $box.offsetHeight;
                }
              };
            }
          }
        });
        this.visitTs(uuid);
      };
    },
    addVisitorReadEvent() {
      const { token, card } = this;
      setInterval(() => {
        // https://docs.winbaoxian.cn/api/client-service/#api-VisitorReadEventStatisticController-addReadEvent
        addVisitorReadEvent({
          appId: BC.APPID,
          userUuid: _get(card, "userUuid"),
          wxAppId: WX_AUTH_PUBLIC_APPID,
          token: token || "",
          eventType: 3,
          intervalTime: 5,
        });
      }, 5000);
    },
    fetchTermsData({ key, name }, username = "") {
      API.liabilities({}, `${key}/liabilities`).then(
        ({ data: { success, data } } = { data: {} }) => {
          this.singleInsurance.name = name;
          this.singleInsurance.imgList = data;
          this.singleInsurance.show = true;
          this.singleInsurance.url = `${BC.baseTermUrl}?nw=1&name=${username}&termsId=${key}`;
        }
      );
    },
    matchData(result) {
      const {
        descShow,
        calData,
        personData,
        tableData,
        accountsData,
        accountMap,
        productNameList,
        productCommonData,
      } = FMT.formatCalculateData(result.resultData, BC.normalizeKeys);

      this.personData = personData;
      this.productCommonData = productCommonData;
      if (personData.insuredInfo) {
        this.insuredAge = parseInt(personData.insuredInfo.age);
      }
      this.tableData = tableData;
      this.accountsData = accountsData;

      result.accountMap = accountMap;
      result.calData = calData;
      result.insuredAge = this.insuredAge;
      result.descShow = descShow;

      this.title = this.settingPbTitle(result);
      this.setPageTitle(this.isPolicyCheck ? "保单信息" : this.title);
      this.tmpData = result;
      this.productNameListData = productNameList;

      const {
        resultData,
        insuranceType,
        categorySortList,
        liabilities,
        trades,
        card,
      } = result;
      if (resultData) {
        const { totalBaof, insuranceTypeId, categorySort, theme } = resultData;
        this.totalBaof = parseFloat(totalBaof);
        this.insuranceTypeId = insuranceTypeId;
        if (Object.keys(BC.insTypeOrders).includes(categorySort)) {
          this.categorySort = categorySort;
        } else {
          this.categorySort = "normal";
        }
        // 保单年检：默认主题优先用链接上的 theme，否则用结果数据里的 theme
        if (this.pbType === 'annual_survey' && URL_PARAM.theme) {
          this.themeSettings.defaultTheme = URL_PARAM.theme;
        } else if (theme) {
          this.themeSettings.defaultTheme = theme;
        }
        if (!this.themeSettings.previewTheme) {
          this.themeSettings.previewTheme = theme || _get(this, 'themeList[0].key');
        }
      }
      if (insuranceType) {
        this.riskType = insuranceType.riskType;
        this.tagList = insuranceType.tagList;
      }
      this.sortList =
        categorySortList && categorySortList.length
          ? categorySortList
          : BC.insTypeOrders[this.categorySort];
      const { accInsList } = FMT.formatLiabilitiesData(
        liabilities,
        this.sortList,
        BC.insTypeName,
        accountMap
      );

      // 默认显示模式
      this.accType = accInsList[0] && accInsList[0].length;
      if (this.isForPresentation) {
        this.showType = 1;
      } else {
        if ((trades || []).length) {
          this.showType = 1;
        } else {
          if (this.dfSort || this.dfSort === 0) {
            this.showType = +this.dfSort;
          } else if (resultData.displayFormatSort) {
            this.showType = BC.SHOW_TYPE[resultData.displayFormatSort];
          }
        }
      }

      this.card = card || {};
      this.footData = {
        insuranceTypeId: this.insuranceTypeId,
        trades: trades,
        ...card,
      };
      this.getIsDataCollectionMissionExist();
    },
    // 关闭封面 {Boolean} hand 手动关闭
    closeCover(hand) {
      if (hand) {
        this.isCoverShow = false;
        this.isPageDone = true;
        setTimeout(() => {
          if (isApp) {
            this.isCoverShow = false;
            this.isPageDone = true;
          }
          this.isCoverShow = false;
        }, BC.ANIMATION_TIME);
        return;
      }
      if (this.coverTimer) clearTimeout(this.coverTimer);
      const endTime = Date.now();
      const stuffTime = endTime - window.startTime;
      if (stuffTime >= BC.COVER_TIME - BC.ANIMATION_TIME) {
        this.isCoverShow = false;
        this.isPageDone = true;
      } else {
        this.coverTimer = setTimeout(() => {
          this.isCoverShow = false;
          this.isPageDone = true;
          setTimeout(() => {
            this.isCoverShow = false;
          }, BC.ANIMATION_TIME);
        }, BC.COVER_TIME - stuffTime - BC.ANIMATION_TIME);
      }
    },
    // 切换显示类型 {Number} showType 显示类型
    toggle(showType) {
      this.showType = showType;
      this.syncDelta({ pbData: { showType } });
    },
    // 责任导航锚点
    insureTypeNav(scrollTop) {
      this.insureNote = this.insureNote || this.$refs.insResultBox;
      if (this.insureNote) {
        const top = this.insureNote.offsetTop;
        this.insTypeNavFixed = scrollTop > top && scrollTop < top + this.insureNote.offsetHeight - 40;
      }
    },
    // 打开病种详情
    openDiseaseBubble(path) {
      this.disease.show = true;
      path = path || {};
      this.disease.activePath = path;
      this.setDiseasePaneHeight();
      this.syncDelta({ pbData: { isDiseasesShow: true, diseasesPath: path } });
    },
    // 打开条款详情
    openTermsBubble(id) {
      this.termsActiveId = id;
      this.syncDelta({
        pbData: {
          isClausesShow: true,
          insuranceId: id,
        },
      });
    },
    // 设置病种内容高度
    setDiseasePaneHeight() {
      this.$nextTick(() => {
        const itemHeight = parseFloat(
          getComputedStyle(
            document.querySelector(".disease-type .nav-list"),
            null
          ).height
        );
        // let hdHeight = parseFloat(getComputedStyle(document.querySelector('.disease-type .hd'), null).height)
        const navHeight = parseFloat(
          getComputedStyle(
            document.querySelector(".disease-type .navigation"),
            null
          ).height
        );
        const filterHeight = 35; // parseFloat(getComputedStyle(document.querySelector('.disease-type .nav-filter'), null).height)
        //  + hdHeight
        if (this.disease.height === itemHeight + filterHeight + navHeight) {
          return;
        }
        this.disease.height = itemHeight + filterHeight + navHeight;
      });
    },
    // 设置页面标题
    setPageTitle(title) {
      document.querySelectorAll("title")[0].innerHTML = title;
      if (appBridge && appBridge.checkAppFeature("CHANGE_WEBVIEW_TITLE")) {
        appBridge.changeWebviewTitle(title);
      }
    },
    // 设置计划书标题
    settingPbTitle(data = {}) {
      const { tsTypeId, isPolicyCheck } = this;
      const { resultData, insuranceType } = data;
      const recipientInfo = _get(resultData, "personData.recipientInfo");
      const prodOrderList = _get(
        resultData,
        "productGroupList[0].prodOrderList"
      );
      // 投保页自定义分享标题
      if (recipientInfo && recipientInfo.title && recipientInfo.shareTitle) {
        return (recipientInfo.shareTitle + "").substring(0, 30);
      }
      // 保单年检
      if (isPolicyCheck) {
        return "家庭保单";
      }
      // 多公司产品 且 非三招两式
      let productTitle;
      if (!tsTypeId && prodOrderList) {
        let multipleProd = [];
        if (Array.isArray(prodOrderList)) {
          prodOrderList.forEach((item, index) => {
            const companyName = item.companyName;
            if (multipleProd.indexOf(companyName) === -1) {
              multipleProd.push(companyName);
            }
            if (!index) productTitle = item.titleName;
          });
        }
        if (multipleProd.length > 1) {
          return "综合保障方案";
        }
      }
      // 对比
      if (resultData.insuranceTypeId == CONFIG.CONTRAST_ID && productTitle) {
        return productTitle;
      }
      return resultData.title || (insuranceType ? insuranceType.name : "");
    },
    setAccountMap(data) {
      const {
        tmpData: { accountMap },
      } = this;
      const { productId, accountInsuranceId, addAndTakeData } = data;
      const currentAccount =
        accountMap &&
        accountMap[productId] &&
        accountMap[productId][accountInsuranceId];
      if (!currentAccount || !addAndTakeData) {
        return;
      }
      currentAccount.addAndTakeData = addAndTakeData;
    },
    // 阅读回执 id 计划书ID
    visitTs(id) {
      let visImg = document.getElementById("transparent");
      if (!visImg || !id) return;
      visImg.src =
        "//img.winbaoxian.com/static/images/planBook/transparent.png";
      visImg.onload = function () {
        API.visitTs({ id });
      };
    },
    // 埋点
    buried(pid, heartSec) {
      let  heartBeatRate = 10000, modelResult;
      if (!BC.bApp) {
        let userAgent = window.navigator.userAgent;
        let output = new UA(userAgent);
        let {
          device: { model },
        } = output;
        if (model) {
          model == "IPHONE" && (model = mobileDevice.model);
        } else {
          model = "未知";
        }
        modelResult = model;
      }

      let projectInfo = {
        url: location.href,
        uuid: this.uuid,
        productId: pid,
      };
      modelResult && (projectInfo.model = modelResult);
      // openId 历史遗留
      this.clientUuid && (projectInfo.openId = this.clientUuid);

      if (heartSec && !isNaN(heartSec)) {
        heartBeatRate = heartSec;
      }
      // 开发环境心跳关闭
      if (IS_LOCALHOST_ENV) {
        heartBeatRate = 999999;
      }
      if (this.isReplay) {
        projectInfo.v = "同屏计划书回放";
      } else if (this.isForPresentation) {
        // 同屏
        projectInfo.v = "同屏计划书";
      }
      if (this.tsType && this.tsTypeId) {
        projectInfo[this.tsType] = this.tsTypeId;
      }

      localStorage.removeItem("PlayingVideoMetadata");
      setInterval(() => {
        let vMetadata = localStorage.getItem("PlayingVideoMetadata")
          ? JSON.parse(localStorage.getItem("PlayingVideoMetadata"))
          : null;
        if (vMetadata) {
          for (let k in vMetadata) {
            projectInfo[k] = vMetadata[k];
          }
        }
      }, 500);
      buriedInit({
        pageId: "JHS_JGY",
        heartBeatRate,
        projectInfo,
      });

      window.onscroll = () => {
        const nScrollTop = DOM.getScrollTop();
        const riskHeight =
          this.$refs.riskPrompt && this.$refs.riskPrompt.$el.clientHeight;
        if (
          !this._haveRead &&
          nScrollTop + DOM.getWindowHeight() >=
            DOM.getScrollHeight() - riskHeight
        ) {
          window.WeiyiStatSDK.submit("fxts");
          this._haveRead = true;
          // window.onscroll = null
        }
        // 计划书2.0 责任导航
        if (this.isTypeToggle) this.insureTypeNav(nScrollTop);
      };
    },
    async getAppParams() {
      let appParams = {};
      if (this.appParams && this.appParams.wxMpAppid) {
        return Promise.resolve(this.appParams);
      }
      try {
        const {
          data: { success, data },
        } = await API.getApplicationInfo();
        if (success && data) {
          if (data.wxMpAppid) {
            appParams.wxMpAppid = data.wxMpAppid;
          }
          if (data.thirdPlatformAppid) {
            appParams.component_appid = data.thirdPlatformAppid;
          }
          this.appParams = appParams;
        }
      } catch (e) {
        appParams.wxMpAppid = BC.wxMpAppid;
      }
      return Promise.resolve(appParams);
    },
    // 开关画笔
    handleToggleBoard() {
      if ((this.isForPresentation && this.isHost) || this.recordingState) {
        // 录屏 isHost = true
        if (this.recordingState) {
          this.isHost = !this.isBoardShow;
        }
        this.isBoardShow = !this.isBoardShow;
        window.WeiyiStatSDK.submit(
          this.isForPresentation ? "tongping_huabi" : "huabi"
        );
      }
    },
    // 同屏讲解-创建房间
    handleToInterpretation() {
      const { uuid, createGroupLock } = this;
      if (createGroupLock) {
        return;
      }
      this.createGroupLock = true;
      API.createGroup({ pbUuid: uuid })
        .then(({ data: { data, success } } = { data: {} }) => {
          if (!success || !data) {
            this.$messagebox.alert("获取讲解房间号失败：", data);
            logger.warn("[分享进房]", "获取讲解房间号失败：", {
              data,
              success,
            });
            this.isPreInvitationShow = false;
            this.hasPendingInvitation = false;
            return;
          }
          this.roomId = data;
          this.handleOpenWechat();
          // 触发进房
          //  - 计时器(非小程序)
          //  - 分享成功回调
          //  - 后退
          this.hasPendingInvitation = true;
          window.setTimeout(() => {
            logger.warn("[分享进房]：", "timeout 触发");
            this.inviteToPresentation();
          }, 30000);
          if (window.appBridge && appBridge.checkAppFeature("SHARING_AWARE")) {
            appBridge.onSharingDone((res) => {
              if (res.success) {
                logger.warn("[分享进房]：", "onSharingDone 触发");
                this.inviteToPresentation();
              }
            });
          }
          if (
            appBridge &&
            appBridge.checkAppFeature("ON_APP_BACK_TO_INPUT_PAGE")
          ) {
            appBridge.onAppBackToInputPage(() => {
              logger.warn("[分享进房]：", "onAppBackToInputPage 触发");
              this.inviteToPresentation();
            });
          }
        })
        .finally(() => {
          this.createGroupLock = false;
        });
    },
    // 同屏讲解-分享
    handleOpenWechat() {
      let {
        miniprogram,
        uuid,
        cardUuid,
        themeSettings,
        roomId,
        shareInfo: { name, img },
        title,
      } = this;
      // 小程序：银保小程序-跳转老的结果页，其余小程序忽略
      if (miniprogram) {
        if (!BC.isMiniBankInsurance) {
          return;
        }
        const miniURL = `/sub/turn/index?${qs.stringify({
          uuid,
          theme: themeSettings.previewTheme || themeSettings.defaultTheme,
          roomId,
        })}`;
        wx.miniProgram.navigateTo({
          url: miniURL,
        });
        return;
      }

      const desc = `${name}邀您进入同屏讲解，快速了解保障方案。`;
      const shareUrl = `${location.origin}${location.pathname}?${qs.stringify({
        uuid,
        cardUuid,
        theme: themeSettings.previewTheme,
        roomId,
        inGroup: true,
      })}`;
      // 企业微信、企业号
      if (
        (BC.isWeCom || BC.isWeEnterprise) &&
        window.WeCom &&
        WeCom.initWeComConfig
      ) {
        WeCom.initWeComConfig({
          title,
          desc,
          link: shareUrl,
          imgUrl: img,
        });
        WeCom.showTopArrow();
        return;
      }
      // app
      if (window.appBridge && appBridge.checkAppFeature("APP_SHARE")) {
        appBridge.share({
          title,
          content: desc,
          imgUrl: img,
          shareUrl,
          shareChannel: ["wechat_friends"],
        });
      }
    },
    // 同屏讲解-分享后，跳转同屏讲解页面
    inviteToPresentation() {
      if (!this.hasPendingInvitation || !this.roomId) {
        return;
      }
      if (BC.isWeCom || BC.isWeEnterprise || this.miniprogram) {
        return;
      }
      this.hasPendingInvitation = false;
      window.location.href = CM.setUrlParam(
        "roomId",
        this.roomId,
        window.location.href
      );
    },
    // #历史状态同步
    synchronousHistory(store) {
      const top =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      this.syncDelta({
        top,
        topCorrection: this.inViewPort(top),
      });
      // TODO: 其他状态
      // const { pbData, boardData } = store
      // const contentBody = Object.assign({}, store)
      // delete contentBody.boardData
      // this.syncDelta(contentBody)
      // if (boardData !== undefined && pbData.isBoardShow) {
      //   setTimeout(() => {
      //     if (Array.isArray(store.boardData)) {
      //       store.boardData.forEach(board => {
      //         this.syncDelta({
      //           boardData: board
      //         })
      //       })
      //     } else {
      //       this.syncDelta({
      //         boardData
      //       })
      //     }
      //   }, 1000)
      // }
    },
    // 同屏记录相关信息保存（版本号、房间号、主题）
    savePresentationInfo() {
      const params = {
        groupId: CM.getUrlParam("roomId"),
        theme: this.themeSettings.previewTheme,
      };
      if (process.env.VUE_APP_REPLAY_VERSION) {
        params.versionNum = process.env.VUE_APP_REPLAY_VERSION;
      }
      API.saveVersionNum(params);
    },
    reset(callback) {
      this.showType = 1;
      this.disease = {
        show: false,
        activePath: [],
        height: 0,
      };
      this.termsActiveId = null;
      this.newInsure = {
        show: false,
        data: {},
      };
      // 责任详情
      this.tmpData.descShow.forEach((prod, index) => {
        this.tmpData.descShow[index] = prod.map(() => false);
      });
      this.replayLoading = true;
      setTimeout(() => {
        this.replayLoading = false;
        if (typeof callback === "function") {
          setTimeout(() => {
            callback();
          }, 1000);
        }
      }, 1000);
      // window.scrollTo({
      //   top: 0,
      //   left: 0
      // })
    },
    // 分享
    async handleShare() {
      const { asConfig } = this;
      const isSupportDirectShowActionSheet = appBridge && appBridge.checkAppFeature("DIRECT_SHOW_ACTION_SHEET");
      if ((isSupportDirectShowActionSheet || APP_CHANNEL === 'NUOYA') && asConfig) {
        const newResultUuid = await this.saveInteractionSetting();
        if (newResultUuid) {
          asConfig.shareGroup.forEach((ele) => {
            ["shareUrl", "path"].forEach((k) => {
              if (!ele[k]) {
                return;
              }
              ele[k] = CM.getUrlByDeletingParam(
                { uuid: newResultUuid },
                ele[k]
              );
              ele[k] = CM.getUrlByAddingParam({ uuid: newResultUuid }, ele[k]);
            });
          });
        }

        if (APP_CHANNEL === 'NUOYA') {
          const wxConfig = asConfig.shareGroup.find((item) => item.action === "wechat_friends");
          const { title, content, imgUrl, shareUrl } = wxConfig;
          shareDirect({ title, content, imgUrl, shareUrl });
        } else {
          appBridge.directShowActionSheet(asConfig);
        }
      }
    },
    // 打开续保保费详情
    handleOpenNewInsureDetail(value) {
      const { tmpData, uuid } = this;
      if (
        !value ||
        !value.insuranceId ||
        !tmpData ||
        !tmpData.resultData ||
        !Array.isArray(tmpData.resultData.productGroupList) ||
        !tmpData.resultData.productGroupList[0]
      ) {
        return;
      }
      const prodOrderList =
        tmpData.resultData.productGroupList[0].prodOrderList;
      if (!prodOrderList || !prodOrderList.length) return;
      let productId;
      prodOrderList.forEach((product) => {
        const mulInsOrderList = product.mulInsOrderList;
        if (!mulInsOrderList.length) return;
        mulInsOrderList.forEach((ins) => {
          if (ins.key === value.insuranceId) productId = product.key;
        });
      });
      if (!productId) return;
      const params = {
        uuid,
        productId,
        insuranceId: value.insuranceId,
      };
      let result = {
        conditions: value.conditions,
      };
      API.getRenewRateList(params)
        .then(({ data: { data, success } } = { data: {} }) => {
          if (success && data) {
            result.feeList = data;
          }
          this.newInsure.data = result;
          this.newInsure.show = true;
        })
        .catch(() => {
          this.newInsure.data = result;
          this.newInsure.show = true;
        });
    },
    screenCapture(done) {
      this.exportPbShow = 0;
      this.isScreenCaptureShow = false;
      // 如果 CashReward 显示，先隐藏它
      const wasDataCollectionVisible = this.isDataCollection;
      if (wasDataCollectionVisible) {
        this.isDataCollection = false;
      }
      setTimeout(() => {
        done().then(() => {
          this.isScreenCaptureShow = true;
          // 截图完成后恢复 CashReward 的显示状态
          if (wasDataCollectionVisible) {
            this.isDataCollection = true;
          }
        }).catch(() => {
          this.isScreenCaptureShow = true;
          // 截图失败也要恢复 CashReward 的显示状态
          if (wasDataCollectionVisible) {
            this.isDataCollection = true;
          }
        });
      }, 1000);
    },
    qaFeedback() {
      if (!this.tsTypeId) return;
      const ax = axios.create({
        baseURL: `${CONTENT_HOSTNAME}/wx/sales/qa/`,
      });
      ax.defaults.withCredentials = true;
      const qaType = this.tsType === "userQaId";
      const params = Object.assign(
        {
          [this.tsType]: Number(this.tsTypeId),
        },
        qaType ? { step: 3 } : null
      );
      ax.post(
        `${qaType ? "feedback" : "familyUserQaId"}?appId=${
          BC.wxMpAppid
        }&token=${this.token}`,
        params
      );
    },
    openInterestSettingPopup() {
      const ref = _get(this, "$refs.InterestDemoV2");
      const fieldRef = _get(
        ref,
        "$refs.overviewHeader[0].$refs.InterestShowFields"
      );
      if (ref) {
        ref.update({
          isShowFieldPopup: true,
        });
      }
      if (fieldRef) {
        fieldRef.scene = "export";
      }
    },
    openThemePicker() {
      const { themeList, themeSettings } = this;
      if (themeSettings) {
        const { previewTheme, defaultTheme } = themeSettings
        const themePopupConfig = {
          visible: true,
          columns: themeList,
          defaultTheme,
          previewTheme
        }
        this.themePopupConfig = themePopupConfig
      }
    },
    onChangeTheme (key) {
      const { themeSettings, themePopupConfig } = this;
      const previewTheme = _get(themePopupConfig, 'previewTheme');
      themeSettings.previewTheme = key || previewTheme
    },
    saveInteractionSetting() {
      const _refInterestDemo = this.$refs.InterestDemoV2;
      return _refInterestDemo ? _refInterestDemo.save() : Promise.resolve();
    },
    async getIsDataCollectionMissionExist() {
      const { tmpData } = this;
      // C端不显示入口
      if (sharePlatform || isShareFormWeApp || shareFrom) return;
      // 诺亚不显示入口
      if(['NUOYA'].includes(APP_CHANNEL)) return;
      // 查询是否存在任务
      const productList = _get(tmpData, 'resultData.productGroupList[0].prodOrderList', []);
      const validProducts = productList.filter((item) => {
        const mulInsOrderList = item.mulInsOrderList;
        return mulInsOrderList && mulInsOrderList.length > 0;
      });

      try {
        for (const item of validProducts) {
          const { key } = item.mulInsOrderList[0];
          const res = await getDataCollectionMissionExist({ insuranceId: key });
          const {
            data: { success, data },
          } = res;
          if (success && data && data.matched) {
            this.matchedProductItem = item;
            this.isDataCollection = true;
            return;
          }
        }
        this.isDataCollection = false;
        this.matchedProductItem = null;
      } catch (error) {
        console.error('查询数据征集任务失败:', error);
        this.isDataCollection = false;
        this.matchedProductItem = null;
      }
    },
    handleCloseCashReward() {
      this.isDataCollection = false;
      this.matchedProductItem = null;
    }
  },
};
</script>

<style lang="less">
@import './index.less';
</style>
